import { render } from "./add-manually.vue?vue&type=template&id=155e12e1"
import script from "./add-manually.vue?vue&type=script&setup=true&lang=js"
export * from "./add-manually.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/add-products/add-manually.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "155e12e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('155e12e1', __exports__)) {
    console.log('reload')
    api.reload('155e12e1', __exports__)
  }
  
  module.hot.accept("./add-manually.vue?vue&type=template&id=155e12e1", () => {
    console.log('re-render')
    api.rerender('155e12e1', render)
  })

}


export default __exports__